/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.FourPawCartGuaranteeControls) return;

  const sourceSelector = '[data-fp-cart-controls]';
  const originalSelector = '.fp-cart-reference-benefits';
  const controlledSelector = '.fp-cart-controlled-reassurance';
  const shippingIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7.5h11.2v8.6H3zM14.2 10h3.1l2.7 3.2v2.9h-5.8z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path><circle cx="7" cy="17.4" r="1.7" fill="currentColor"></circle><circle cx="17.6" cy="17.4" r="1.7" fill="currentColor"></circle></svg>';
  const trialIcon = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.5 19 6v5.2c0 4.4-2.7 7.7-7 9.3-4.3-1.6-7-4.9-7-9.3V6l7-2.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path><path d="m8.8 12 2.1 2.1 4.4-4.4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  let observer;
  let frame;

  const activeSource = () => {
    const sources = document.querySelectorAll(sourceSelector);
    return sources[sources.length - 1];
  };
  const readConfig = (source) => {
    const script = source?.querySelector('[data-fp-cart-controls-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };
  const buildItem = (key, title, text, icon) => {
    const item = document.createElement('span');
    item.className = 'fp-cart-controlled-reassurance__item';
    item.dataset.fpCartReassurance = key;
    const iconNode = document.createElement('span');
    iconNode.className = 'fp-cart-controlled-reassurance__icon';
    iconNode.setAttribute('aria-hidden', 'true');
    iconNode.innerHTML = icon;
    const copyNode = document.createElement('span');
    copyNode.className = 'fp-cart-controlled-reassurance__copy';
    const heading = document.createElement('strong');
    heading.innerHTML = title;
    copyNode.append(heading);
    if (text) {
      const supporting = document.createElement('small');
      supporting.innerHTML = text;
      copyNode.append(supporting);
    }
    item.append(iconNode, copyNode);
    return item;
  };
  const surfaceHasHandle = (surface, handles = '') => {
    const itemScope = surface.id === 'main-cart-footer'
      ? document.querySelector('#main-cart-items')
      : surface;
    if (!itemScope) return false;
    return handles
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean)
      .some((handle) => itemScope.querySelector(`.cart-item--product-${CSS.escape(handle)}`)
        || [...itemScope.querySelectorAll('.cart-item a[href*="/products/"]')]
          .some((link) => link.getAttribute('href')?.includes(`/products/${handle}`)));
  };
  const setVisibility = (drawer, selector, hidden, dataKey) => {
    drawer.querySelectorAll(selector).forEach((element) => {
      if (hidden) element.dataset[dataKey] = 'true';
      else delete element.dataset[dataKey];
    });
  };
  const unlockQuantity = (wrapper) => {
    delete wrapper.dataset.fpCartQuantityLocked;
    wrapper.querySelector('[data-fp-cart-locked-quantity]')?.remove();
    wrapper.querySelectorAll('[data-fp-cart-quantity-control]').forEach((control) => {
      delete control.dataset.fpCartQuantityControl;
      control.removeAttribute('aria-hidden');
    });
  };
  const restoreLockedQuantities = () => {
    document.querySelectorAll('[data-fp-cart-quantity-locked]').forEach(unlockQuantity);
  };
  const renderLockedQuantities = (config) => {
    const handles = config.lockQuantity && config.lockedProductHandles
      ? config.lockedProductHandles.split(',').map((handle) => handle.trim()).filter(Boolean)
      : [];
    const targets = new Set();
    handles.forEach((handle) => {
      document.querySelectorAll(`.cart-item--product-${CSS.escape(handle)} .cart-item__quantity-wrapper`)
        .forEach((wrapper) => targets.add(wrapper));
    });
    document.querySelectorAll('[data-fp-cart-quantity-locked]').forEach((wrapper) => {
      if (!targets.has(wrapper)) unlockQuantity(wrapper);
    });
    targets.forEach((wrapper) => {
          const quantity = wrapper.querySelector('input[name="updates[]"]')?.value || '1';
          let locked = wrapper.querySelector('[data-fp-cart-locked-quantity]');
          if (!locked) {
            wrapper.dataset.fpCartQuantityLocked = 'true';
            wrapper.querySelectorAll('quantity-input, .quantity').forEach((control) => {
              control.dataset.fpCartQuantityControl = 'true';
              control.setAttribute('aria-hidden', 'true');
            });
            locked = document.createElement('span');
            locked.dataset.fpCartLockedQuantity = 'true';
            locked.className = 'fp-cart-locked-quantity';
            locked.innerHTML = '<span class="fp-cart-locked-quantity__label"></span><strong></strong>';
            wrapper.prepend(locked);
          }
          const label = locked.querySelector('.fp-cart-locked-quantity__label');
          const value = locked.querySelector('strong');
          if (label.textContent !== config.quantityLabel) label.textContent = config.quantityLabel;
          if (value.textContent !== quantity) value.textContent = quantity;
    });
  };
  const renderSurface = (surface, config) => {
    const original = surface.querySelector(originalSelector);
    const checkoutArea = surface.querySelector('.cart__ctas');
    if (!checkoutArea) return;
    if (original) original.dataset.fpCartOriginalBenefits = 'true';

    let controlled = surface.querySelector(controlledSelector);
    if (!controlled) {
      controlled = document.createElement('div');
      controlled.className = 'fp-cart-controlled-reassurance';
      checkoutArea.after(controlled);
    } else if (controlled.previousElementSibling !== checkoutArea) {
      checkoutArea.after(controlled);
    }

    const signature = JSON.stringify(config);
    if (controlled.dataset.fpCartSignature !== signature) {
      const items = [];
      if (config.showShipping) {
        items.push(buildItem('shipping', config.shippingTitle, config.shippingText, shippingIcon));
      }
      if (config.showTrial) {
        items.push(buildItem('trial', config.trialTitle, config.trialText, trialIcon));
      }
      controlled.replaceChildren(...items);
      controlled.hidden = items.length === 0;
      controlled.classList.toggle('fp-cart-controlled-reassurance--single', items.length === 1);
      controlled.dataset.fpCartSignature = signature;
    }

    let deliveryExpectation = surface.querySelector('[data-fp-cart-delivery-expectation]');
    if (config.deliveryExpectation && surfaceHasHandle(surface, config.deliveryExpectationHandles)) {
      if (!deliveryExpectation) {
        deliveryExpectation = document.createElement('p');
        deliveryExpectation.className = 'fp-cart-delivery-expectation';
        deliveryExpectation.dataset.fpCartDeliveryExpectation = 'true';
        controlled.after(deliveryExpectation);
      }
      if (deliveryExpectation.textContent !== config.deliveryExpectation) {
        deliveryExpectation.textContent = config.deliveryExpectation;
      }
    } else {
      deliveryExpectation?.remove();
    }

    controlled.setAttribute('role', 'group');
    controlled.setAttribute('aria-label', config.accessibilityLabel);
    controlled.style.setProperty('--fp-cart-control-heading-mobile', `${config.headingMobile}px`);
    controlled.style.setProperty('--fp-cart-control-heading-desktop', `${config.headingDesktop}px`);
    controlled.style.setProperty('--fp-cart-control-text-mobile', `${config.textMobile}px`);
    controlled.style.setProperty('--fp-cart-control-text-desktop', `${config.textDesktop}px`);
    controlled.style.setProperty('--fp-cart-control-text', config.textColor);
    controlled.style.setProperty('--fp-cart-control-muted', config.mutedColor);
    controlled.style.setProperty('--fp-cart-control-icon', config.iconColor);
    controlled.style.setProperty('--fp-cart-control-divider', config.dividerColor);
    surface.style.setProperty('--fp-cart-control-checkout-background', config.checkoutButtonColor);

    setVisibility(surface, '.fp-cart-installments', !config.showInstallments, 'fpCartInstallmentsHidden');
    setVisibility(
      surface,
      '.payment-badges-block, .cart__dynamic-checkout-buttons.additional-checkout-buttons',
      !config.showPaymentBadges,
      'fpCartPaymentBadgesHidden'
    );
    surface.querySelector('#CartDrawer-Checkout, #checkout')
      ?.style.setProperty('--fp-cart-control-checkout-background', config.checkoutButtonColor);
  };
  const restore = () => {
    document.querySelectorAll(controlledSelector).forEach((element) => element.remove());
    document.querySelectorAll('[data-fp-cart-delivery-expectation]').forEach((element) => element.remove());
    document.querySelectorAll('[data-fp-cart-original-benefits]').forEach((element) => {
      delete element.dataset.fpCartOriginalBenefits;
    });
    document.querySelectorAll('[data-fp-cart-installments-hidden]').forEach((element) => {
      delete element.dataset.fpCartInstallmentsHidden;
    });
    document.querySelectorAll('[data-fp-cart-payment-badges-hidden]').forEach((element) => {
      delete element.dataset.fpCartPaymentBadgesHidden;
    });
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach((button) => {
      button.style.removeProperty('--fp-cart-control-checkout-background');
    });
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach((surface) => {
      surface.style.removeProperty('--fp-cart-control-checkout-background');
    });
    restoreLockedQuantities();
  };
  const apply = () => {
    const config = readConfig(activeSource());
    if (!config) {
      restore();
      return;
    }
    document.querySelectorAll('cart-drawer, #main-cart-footer')
      .forEach((surface) => renderSurface(surface, config));
    renderLockedQuantities(config);
  };
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      apply();
    });
  };
  const relevantMutation = (record) => {
    const selector = 'cart-drawer, #main-cart-footer, [data-fp-cart-controls]';
    if (record.target?.matches?.(selector) || record.target?.closest?.(selector)) return true;
    return [...record.addedNodes, ...record.removedNodes].some((node) => node instanceof Element && (
      node.matches(selector) || node.querySelector(selector)
    ));
  };
  const start = () => {
    if (!observer) {
      observer = new MutationObserver((records) => {
        if (records.some(relevantMutation)) schedule();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:block:select', schedule);
  window.FourPawCartGuaranteeControls = Object.freeze({ apply, restore });
})();
